<gbc-tile [title]="'weather-curve-tile.title' | translate">
  @if (editingEnabled$ | async) {
    <div
      gbc-tile-right
      class="adjust-curve"
      [ngClass]="{ editing: editing }"
      (click)="adjustCurveClicked()"
      role="button"
      >
      <button gbc-icon-button gbc-tile-right data-test-id="adjust-curve">
        <img src="./assets/svgs/adjust-outline-black.svg" />
      </button>
    </div>
  }
  <div class="container">
    <!-- Highcharts does not support automatic resizing, so we just render a new one when toggling editing -->
    @if (!editing) {
      <app-weather-curve-chart [outdoorTemp$]="outdoorTemp$" [data$]="data$"> </app-weather-curve-chart>
    }
    @if (editing) {
      <app-weather-curve-chart class="editing" [outdoorTemp$]="outdoorTemp$" [data$]="data$"> </app-weather-curve-chart>
    }
    @if (editing) {
      <app-weather-curve-form
        [initialCurve]="curve$ | async"
        (currentCurve)="updateCurve($event)"
        (cancel)="cancelEditing()"
        (submitWeatherCurve)="formSubmitted($event)"
        >
      </app-weather-curve-form>
    }
  </div>
</gbc-tile>
